<template>
	<div class="py-4 container-fluid">
    <div class="row">
        <div class="col-md-12">
					<div class="card" v-if="isLoading">
						<Loading/>
					</div>
          <div class="card" v-if="!isLoading">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Contrato {{ contract.Name }}</p>
              </div>
            </div>
            <div class="card-body">
              <p class="text-uppercase text-sm">	Detalles</p>
              <div class="row">
                <div class="col-md-6 col-12">
                  <label for="example-text-input" class="form-control-label"
                    >Cliente</label
                  >
                  <argon-input type="text" v-model="contract.Cliente__c.Name" disabled="true" />
                </div>
                <div class="col-md-6 col-12">
                  <label for="example-text-input" class="form-control-label"
                    >Estado</label
                  >
                  <argon-input type="text" v-model="contract.EstadoDeCampana__c" disabled="true" />
                </div>
                <div class="col-md-6 col-12">
                  <label for="example-text-input" class="form-control-label"
                    >Marca</label
                  >
                  <argon-input type="text" v-model="contract.Marca__c.Name" disabled="true" />
                </div>
                <div class="col-md-6 col-12">
                  <label for="example-text-input" class="form-control-label"
                    >Nombre de campaña</label
                  >
                  <argon-input type="text" v-model="contract.NombreCampana__c" disabled="true" />
                </div>
                <div class="col-md-6 col-12">
                  <label for="example-text-input" class="form-control-label"
                    >Inversión en dolares</label
                  >
                  <argon-input type="text" v-model="contract.Monto_Total_USD" disabled="true" />
                </div>
                <div class="col-md-6 col-12">
                  <label for="example-text-input" class="form-control-label"
                    >Progreso de la campaña</label
                  >
                  <argon-input type="text" v-model="contract.Progreso_Campana" disabled="true" />
                </div>
                <div class="col-md-6 col-12">
                  <label for="example-text-input" class="form-control-label"
                    >Estado de las instalaciones</label
                  >
                  <argon-input type="text" v-model="contract.Estado_Instalaciones" disabled="true" />
                </div>
                <div class="col-md-6 col-12">
                  <label for="example-text-input" class="form-control-label"
                    >Progreso de las instalaciones</label
                  >
                  <argon-input type="text" v-model="contract.Progreso_Instalaciones" disabled="true" />
                </div>
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Medios incluídos</label
                  >
                  <argon-input type="text" v-model="contract.MediosIncluidosEnContrato__c" disabled="true" />
                </div>
              </div>
              <hr class="horizontal dark" />
              <div class="nav nav-tabs nav-fill" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                  <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#installs" type="button" role="tab" aria-controls="installs" aria-selected="true">Ejecuciones de contrato</button>
                </li>
              </div>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="installs" role="tabpanel" aria-labelledby="installs-tab">
                  <!-- <p class="text-uppercase text-sm text-center">	Detalles de instalaciones</p> -->
                  <div class="table-responsive" v-if="hasInstalls">
                    <table class="table align-items-center">
                      <tbody>
                        <Loading v-if="isLoading"/>
                        <tr v-for="(install, index) in excecutions" :key="index">
                          <td >
                            <div class="px-2 py-1 d-flex align-items-center">
                              <div class="ms-4">
                                <p class="mb-0 text-xs font-weight-bold">Código:</p>
                                <h6 class="mb-0 text-sm"><a :href="'/campaign/'+install._id">{{ install.Name }}</a></h6>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="text-center">
                              <p class="mb-0 text-xs font-weight-bold">Marca:</p>
                              <h6 class="mb-0 text-sm">{{ install.Marca__c }}</h6>
                            </div>
                          </td>
                          <td class="text-sm align-middle">
                            <div class="text-center col">
                              <p class="mb-0 text-xs font-weight-bold">País:</p>
                              <h6 class="mb-0 text-sm">{{ install.Pais__c }}</h6>
                            </div>
                          </td>
                          <td class="text-sm align-middle">
                            <div class="text-center col">
                              <p class="mb-0 text-xs font-weight-bold">Fecha Inicio:</p>
                              <h6 class="mb-0 text-sm" v-if="install.Campana__c.FechaDeInicio__c !=null">{{ getFormattedDate(install.Campana__c.FechaDeInicio__c) }}</h6>
                            </div>
                          </td>
                          <td class="text-sm align-middle">
                            <div class="text-center col">
                              <p class="mb-0 text-xs font-weight-bold">Fecha Fin:</p>
                              <h6 class="mb-0 text-sm" v-if="install.Campana__c.FechaDeFinalizacion__c !=null">{{ getFormattedDate(install.Campana__c.FechaDeFinalizacion__c) }}</h6>
                            </div>
                          </td>
                          <td class="text-sm align-middle">
                            <div class="text-center col">
                              <p class="mb-0 text-xs font-weight-bold">Estado:</p>
                              <h6 class="mb-0 text-sm">{{ install.EstadoDeCampana__c }}</h6>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="!hasInstalls" class="text-center">
                    <img :src="folder" style="max-width: 20%;"/> 
                    <h4>No se encontraron registros</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
  import Loading from '../../examples/Loading.vue';
  import moment from 'moment';
	import ArgonInput from "@/components/ArgonInput.vue";
  import folder from "@/assets/img/folder.png";

  export default {
    name: "tables",
    components: {
      Loading,
			ArgonInput,
    },
    data() {
      return {
        folder,
        contract:{
          Id:null,
					Name:null,
					Cliente__c:null,
					Agencia__c:null,
					EstadoDeCampana__c:null,
          RepresentanteCliente__c:null,
          Monto_Total_USD:null,
          Progreso_Instalaciones:null,
          Progreso_Campana:null,
          Estado_Instalaciones:null,
          Marca__c:{
            Name:null
          },
          MediosIncluidosEnContrato__c:null
				},
        excecutions:[],
        medios:[],
        isLoading:false,
        hasInstalls:false,
        hasMedios:false
      };
    },
    methods:{
      async fetchContract(){
        this.isLoading=true;
				let idContract = this.$route.params.id;
        fetch(this.$EndPoint+'campanas/get_contract/'+idContract)
        .then(response=>response.json())
        .then(result=>{
          console.log(result);
          this.contract=result;
          this.fetchEjecuciones(this.contract.Name);
        })
      },
      
      async fetchEjecuciones(contractId){
        fetch(this.$EndPoint+'ejecuciones/get_by_contract/'+contractId)
        .then(response=>response.json())
        .then(result=>{
          console.log(result);
          this.excecutions=result;
          this.fetchMedios();
          if(this.excecutions.length>0){
            this.hasInstalls=true;
          }else{
            this.hasInstalls=false;
          }
          console.log('HasInstalls: '+ this.hasInstalls);
          this.isLoading=false;
        })
      },

      async fetchMedios(){
        this.isLoading=true;
				let idContract = this.contract.Id;
        fetch(this.$EndPoint+'medios/get_by_contrat/'+idContract)
        .then(response=>response.json())
        .then(result=>{
          console.log('medios');
          console.log(result);
          this.medios=result;
          if(this.medios.length>0){
            this.hasMedios=true;
          }else{
            this.hasMedios=false;
          }
          this.isLoading=false;
        })
      },

      getFormattedDate(date) {
            return moment(date).format("YYYY-MM-DD")
        }
    },
    created(){
      if(localStorage.getItem('IsLoggedIn')=='true'){
        this.fetchContract();
      }else{
        this.$router.push('/signin')
      }
    }
  };
</script>